export const coins = [
    {
        name: 'MATIC',
        address: '0x0000000000000000000000000000000000001010',
    },
    {
        name: 'TST',
        address: '0x2d7882beDcbfDDce29Ba99965dd3cdF7fcB10A1e',
    },
    {
        name: 'LINK',
        address: '0x326C977E6efc84E512bB9C30f76E30c160eD06FB',
    },
];
